module.exports = __webpack_public_path__ + "static/media/cccd_before.0ecc831c.png";